import React from 'react';
import PropTypes from 'prop-types';

import { getMakeModelYearLinkUrl } from 'site-modules/shared/utils/vehicle-link-constructor';
import { vdpLinkBuilder } from 'site-modules/shared/utils/vdp-link-constructor';
import { makeNiceName } from 'site-modules/shared/utils/nice-name';

import { Link } from 'site-modules/shared/components/link/link';

export function RecentlyViewedItem({ item }) {
  const { makeName, modelName, year, vin } = item;
  const title = `${year} ${makeName} ${modelName}`;
  const make = makeNiceName(makeName);
  const model = makeNiceName(modelName);
  const link = vin
    ? vdpLinkBuilder({ make, model, year, vin })
    : getMakeModelYearLinkUrl({ makeSlug: make, modelSlug: model, year });

  const trackingId = vin ? 'return_dashboard_view_vin_details' : 'return_dashboard_mmy_select';
  return (
    <Link
      to={link}
      rel="nofollow"
      data-tracking-id={trackingId}
      className="pos-r d-flex align-items-center text-underline text-cool-gray-30 fw-normal medium"
    >
      {title}
    </Link>
  );
}

RecentlyViewedItem.propTypes = {
  item: PropTypes.shape({
    makeName: PropTypes.string,
    modelName: PropTypes.string,
    year: PropTypes.number,
    vin: PropTypes.string,
  }).isRequired,
};
